import React from 'react';
import { Container, Accordion, Card, Badge } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const sections = [
  {
    title: "Content Preparation",
    items: [
      "Use 2–3 high-quality reference textbooks per course, each ideally under 1000 pages.",
      "Ensure reference materials are structured and aligned with your curriculum.",
      "Avoid using fragmented or inconsistent sources."
    ]
  },
  {
    title: "Content Generation Approach",
    items: [
      "Generate content one unit at a time for better quality and coherence.",
      "Review each unit before proceeding to the next.",
      "Avoid generating the entire course in a single step."
    ]
  },
  {
    title: "Standards Alignment",
    items: [
      "Select a single Content Standard (e.g., NEP, AICTE, ABET) for the entire project.",
      "Use one consistent Taxonomy Standard (e.g., Bloom’s) across all units.",
      "Do not change standards midway through the course."
    ]
  },
  {
    title: "Curriculum Design",
    items: [
      "Define modules, units, and topics clearly before starting generation.",
      "Ensure each topic represents a single, well-defined concept.",
      "Avoid overly broad or ambiguous topic definitions."
    ]
  },
  {
    title: "Learning Outcomes",
    items: [
      "Use appropriate action verbs based on desired cognitive level.",
      "Ensure outcomes align with the selected taxonomy.",
      "Maintain consistency in difficulty progression across units."
    ]
  },
  {
    title: "Content Review",
    items: [
      "Review generated content for completeness and clarity.",
      "Check for repetition or missing sections.",
      "Ensure all key concepts are adequately covered."
    ]
  },
  {
    title: "Assessment Alignment",
    items: [
      "Ensure assessments cover all major concepts.",
      "Match question types with topic complexity.",
      "Maintain alignment between learning outcomes and assessments."
    ]
  },
  {
    title: "SME Enhancement",
    items: [
      "Add institutional examples, case studies, and real-world context.",
      "Customize content to reflect local or industry relevance.",
      "Use SME review to enhance depth and applicability."
    ]
  }
];

const BestPractices = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />

    <Container className="py-5 flex-grow-1">
      <div className="text-center mb-5">
        <Badge bg="primary">AcademicOS User Guide</Badge>
        <h1 className="fw-bold mt-2">Best Practices for Academic Content Development</h1>
        <p className="text-muted">
          Practical guidelines for faculty and academic teams to ensure high-quality, consistent, and standards-aligned content generation.
        </p>
      </div>

      <Accordion defaultActiveKey="0">
        {sections.map((sec, idx) => (
          <Accordion.Item eventKey={idx.toString()} key={idx}>
            <Accordion.Header>{sec.title}</Accordion.Header>
            <Accordion.Body>
              {sec.items.map((item, i) => (
                <Card key={i} className="mb-2 border-0 bg-light">
                  <Card.Body>{item}</Card.Body>
                </Card>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>

    <AppFooter />
  </div>
);

export default BestPractices;
